import { useEffect } from "react";

/**
 * Single passive scroll listener that writes `window.scrollY` into a CSS custom
 * property (`--scroll-y`) on documentElement. CSS layers then read it via
 * `translate3d(0, calc(var(--scroll-y) * -0.15), 0)` for smooth, GPU-driven
 * parallax with zero React re-renders.
 *
 * Mount once at the top of a page - the effect is idempotent.
 */
export function useParallax() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    let ticking = false;
    const update = () => {
      document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
}
